import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="field-grid-light bg-cream-100 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22etxqj6b0mv2">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yet6tz20qj74">
        <div className="text-center" data-id="element-22" data-mp="1anxmto3t0saf">
          <span className="inline-flex items-center gap-2 rounded-md bg-gold-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-forest-950" data-id="element-23" data-mp="1aoyvjlxcl2oz">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jhap3gnrd696" /> Incluidos sin costo extra
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-forest-950 sm:text-4xl" data-id="element-25" data-mp="1epskmimj0njg">
            Los {totalBonuses} Bonos Estratégicos
          </h2>
        </div>

        <div className="mt-10 grid gap-5" data-id="element-26" data-mp="mz4kn9wl9o7d">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-6 rounded-xl border border-earth-200 bg-white p-6 shadow-sm shadow-earth-900/5 sm:p-8 md:grid-cols-[220px_1fr]" data-id="element-27" data-mp="29rjtincsmb9a" data-mpi={index}>
                <div className="flex items-start justify-between gap-4 md:flex-col md:justify-start" data-id="element-28" data-mp="1vtd4zxtqhnma">
                  <div className="flex items-center gap-3 md:flex-col md:items-start" data-id="element-29" data-mp="20qd94370wgar">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-forest-800 text-gold-300" data-id="element-30" data-mp="25qrippo9vyaw">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-31" data-mp="3c5s9lgyfxqam" />
                    </span>
                    <p className="text-xs font-extrabold uppercase tracking-[.16em] text-earth-500" data-id="element-32" data-mp="3h4bt7apkapzt">Bono {bonus.number}</p>
                  </div>
                  <p className="text-right text-xs font-bold text-earth-500 md:text-left" data-id="element-33" data-mp="1c4atmzpgfdfu">
                    <span className="block line-through" data-id="element-34" data-mp="1c6ok0v96w1h2">Valor real: {bonus.value}</span>
                    <span className="mt-2 inline-block rounded-md bg-gold-500 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-forest-950" data-id="element-35" data-mp="1q1zc60w1u8hq">
                      Gratis
                    </span>
                  </p>
                </div>

                <div className="flex flex-col" data-id="element-36" data-mp="tevr10u4eg9c">
                  <h3 className="text-xl font-extrabold leading-tight text-forest-950" data-id="element-37" data-mp="tbzvtk9nq5ol">{bonus.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-earth-800" data-id="element-38" data-mp="12eivjvi5c26m">{bonus.description}</p>

                  {bonus.listLabel && <p className="mt-4 text-sm font-semibold text-forest-900" data-id="element-39" data-mp="envas9n4ti2n">{bonus.listLabel}</p>}

                  {bonus.items && <ul className="mt-4 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-40" data-mp="jeghvmjzprs">
                      {bonus.items.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-earth-900" data-id="element-41" data-mp="5acz51v0kzy7">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-700" aria-hidden="true" data-id="element-42" data-mp="3mre3f4u8jtv3" />
                          {item}
                        </li>)}
                    </ul>}

                  {bonus.note && <p className="mt-4 text-sm italic leading-relaxed text-earth-700" data-id="element-43" data-mp="j7tamrs63jwt">{bonus.note}</p>}

                  {bonus.benefit && <p className="mt-5 rounded-lg border-l-4 border-gold-500 bg-forest-50 px-4 py-3 text-sm font-semibold text-forest-900" data-id="element-44" data-mp="9chrlx9q7qj9">
                      {bonus.benefit}
                    </p>}
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border-2 border-gold-500 bg-forest-900 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-45" data-mp="2z237q1rqspnt">
          <div data-id="element-46" data-mp="3agwt4bv6iyat">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-forest-100" data-id="element-47" data-mp="3agezlmzwiy6l">
              Valor total de los {totalBonuses} bonos
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold tracking-tight text-cream line-through decoration-red-400 decoration-2" data-id="element-48" data-mp="30jacnky8eyoq">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-49" data-mp="3t87fqgtvgoww">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-forest-100" data-id="element-50" data-mp="3t992hik92zug">Tu precio hoy</p>
            <p className="mt-1 inline-flex items-center gap-2 font-display text-3xl font-extrabold tracking-tight text-gold-400" data-id="element-51" data-mp="3o7a0ac08y8z3">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-52" data-mp="3jc4inpdvnggt" /> GRATIS
            </p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-earth-700" data-id="element-53" data-mp="27uuvarrmo4a8">
          Solo incluidos en esta oferta.
        </p>
      </div>
    </section>;
}